<script lang="ts">
	import type { Icon } from '#lib/types/icons.js';
	import Svg from './svg.svelte';

	interface Props {
		color?: string;
		icon: Icon | string;
	}

	let { color = 'currentColor', icon }: Props = $props();
</script>

<div
	class="absolute pointer-events-none w-full h-full -bottom-[20%] -right-[45%]"
	style="color: {color}"
>
	<Svg src={icon} className="w-1/2 h-2/3 rotate-6 opacity-20 scale-130" />
</div>
